export class Activity {    
        
    public static readonly READ = 1;
    public static readonly WRITE = 2;
    public static readonly DELETE = 3;   
    
    
    
}
